<app-admin-student-platform-header></app-admin-student-platform-header>

<section class="user-management">
  <!-- HEADER -->
  <div class="header">
    <div>
      <h1>User Management</h1>
      <p>View and manage registered users</p>
    </div>
  </div>

  <div class="stats-toolbar">
    <div class="stats-heading"></div>
    <div class="d-flex">
      <div class="today">{{ statsFilterLabel }}</div>
      <div class="drp-wrapper">
        <div
          class="drp-backdrop"
          *ngIf="showStatsDatePicker"
          (click)="showStatsDatePicker = false"
        ></div>

        <button
          class="drp-trigger"
          (click)="toggleStatsDatePicker($event)"
          [class.drp-active]="statsPickerStartDate"
        >
          <span class="material-icons drp-cal-icon"> calendar_today </span>

          <span class="drp-label">
            {{ statsDisplayLabel }}
          </span>

          <span class="material-icons drp-chevron"> expand_more </span>
        </button>

        <div
          class="drp-panel"
          *ngIf="showStatsDatePicker"
          (click)="$event.stopPropagation()"
        >
          <div class="drp-nav">
            <button
              class="drp-nav-btn"
              type="button"
              (click)="statsPrevMonth()"
            >
              <span class="material-icons">chevron_left</span>
            </button>

            <span class="drp-month-label"> {{ statsMonthLabel }}</span>

            <button
              class="drp-nav-btn"
              type="button"
              (click)="statsNextMonth()"
            >
              <span class="material-icons">chevron_right</span>
            </button>
          </div>

          <div class="drp-grid">
            <div class="drp-weekday" *ngFor="let day of pickerWeekDays">
              {{ day }}
            </div>
            <div
              *ngFor="let day of statsPickerCalendarDays"
              class="drp-day"
              [class.drp-empty]="!day"
              [class.drp-start]="statsIsStart(day)"
              [class.drp-end]="statsIsEnd(day)"
              [class.drp-in-range]="statsIsInRange(day)"
              [class.drp-today]="statsIsToday(day)"
              (click)="day && statsSelectDay(day)"
              (mouseenter)="statsPickerHoverDate = day"
              (mouseleave)="statsPickerHoverDate = null"
            >
              {{ day ? day.getDate() : "" }}
            </div>
          </div>

          <div class="drp-footer">
            <span class="drp-range-label">
              Custom Date Range
              <strong *ngIf="statsPickerStartDate || statsPickerEndDate">
                {{ statsDisplayLabel }}
              </strong>
            </span>
            <div class="drp-actions">
              <button
                type="button"
                class="drp-clear-btn"
                (click)="clearStatsDatePicker()"
              >
                Clear
              </button>
              <button
                type="button"
                class="drp-apply-btn"
                (click)="applyStatsDatePicker()"
                [disabled]="!statsPickerStartDate"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="stats-grid"
    *ngIf="(stats && stats.length > 0) || (companyStats && companyStats.length > 0)"
  >
    <div class="stat-card" *ngFor="let stat of stats">
      <div class="icon" [ngClass]="stat.iconBg">
        <span class="material-icons">{{ stat.icon }}</span>
      </div>
      <div class="content">
        <span class="title">{{ stat.title }}</span>
        <span class="value">{{ stat.value }}</span>
        <span class="subtitle">{{ stat.subtitle }}</span>
      </div>
    </div>

    <div class="stat-card" *ngFor="let card of companyStats">
      <div class="icon" [ngClass]="card.iconBg">
        <span class="material-icons">{{ card.icon }}</span>
      </div>
      <div class="content">
        <span class="title">{{ card.title }}</span>
        <span class="value">{{ card.value }}</span>
        <span class="subtitle" *ngIf="card.subtitle">{{ card.subtitle }}</span>
      </div>
    </div>
  </div>

  <!-- TABS -->
  <div class="tabs-header">
    <div class="tabs">
      <button
        class="tab"
        [class.active]="activeTab === 'users'"
        (click)="setTab('users')"
        *ngIf="allowedTabs.includes('users')"
      >
        <span class="material-icons">group</span> Users
      </button>

      <button
        class="tab"
        [class.active]="activeTab === 'enrollments'"
        (click)="setTab('enrollments')"
        *ngIf="allowedTabs.includes('enrollments')"
      >
        <span class="material-icons">menu_book</span> Enrollments
      </button>

      <button
        class="tab"
        [class.active]="activeTab === 'quizzes'"
        (click)="setTab('quizzes')"
        *ngIf="allowedTabs.includes('quizzes')"
      >
        <span class="material-icons">quiz</span> Quizzes
      </button>
    </div>

    <button
      *ngIf="activeTab === 'users'"
      class="export-btn"
      (click)="exportUsers()"
      [disabled]="isExporting"
    >
      <span class="material-icons">
        {{ isExporting ? "hourglass_empty" : "download" }}
      </span>
      {{ isExporting ? "Exporting..." : "Export" }}
    </button>
  </div>

  <div class="search-filter-row">
    <div class="search-box">
      <span class="material-icons">search</span>
      <input
        type="text"
        placeholder="Search..."
        [(ngModel)]="searchTerm"
        (input)="onSearchInput()"
      />
      <button
        type="button"
        class="clear-search-btn"
        *ngIf="searchTerm"
        (click)="clearSearch()"
        title="Clear search"
      >
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Custom Filter Dropdown -->
    <div class="status-filter-wrapper" *ngIf="activeTab === 'users'">
      <div
        class="status-backdrop"
        *ngIf="showStatusDropdown"
        (click)="showStatusDropdown = false"
      ></div>
      <button
        type="button"
        class="status-trigger"
        (click)="toggleStatusDropdown($event)"
        [class.status-active]="userPaymentStatus !== 'all'"
      >
        <i class="bi bi-funnel filter-icon"></i>
        <span class="status-label">{{
          userPaymentStatus === "all" ? "All" : (userPaymentStatus | titlecase)
        }}</span>
        <i
          class="bi bi-chevron-down dropdown-arrow"
          [class.rotated]="showStatusDropdown"
        ></i>
      </button>

      <div
        class="status-panel"
        *ngIf="showStatusDropdown"
        (click)="$event.stopPropagation()"
      >
        <div
          class="status-option"
          [class.selected]="userPaymentStatus === 'all'"
          (click)="selectStatus('all')"
        >
          <span>All</span>
          <i
            class="bi bi-check2 check-icon"
            *ngIf="userPaymentStatus === 'all'"
          ></i>
        </div>
        <div
          class="status-option"
          [class.selected]="userPaymentStatus === 'pending'"
          (click)="selectStatus('pending')"
        >
          <span>Pending</span>
          <i
            class="bi bi-check2 check-icon"
            *ngIf="userPaymentStatus === 'pending'"
          ></i>
        </div>
        <div
          class="status-option"
          [class.selected]="userPaymentStatus === 'paid'"
          (click)="selectStatus('paid')"
        >
          <span>Paid</span>
          <i
            class="bi bi-check2 check-icon"
            *ngIf="userPaymentStatus === 'paid'"
          ></i>
        </div>
      </div>
    </div>

    <!-- Custom Date Range Picker -->
    <div class="drp-wrapper" *ngIf="activeTab === 'users'">
      <!-- Backdrop: closes picker when clicking outside -->
      <div
        class="drp-backdrop"
        *ngIf="showDatePicker"
        (click)="showDatePicker = false"
      ></div>

      <button
        class="drp-trigger"
        (click)="toggleDatePicker($event)"
        [class.drp-active]="pickerStartDate"
      >
        <span class="material-icons drp-cal-icon">calendar_today</span>
        <span class="drp-label">{{ pickerDisplayLabel }}</span>
        <span class="material-icons drp-chevron">expand_more</span>
      </button>

      <div
        class="drp-panel"
        *ngIf="showDatePicker"
        (click)="$event.stopPropagation()"
      >
        <!-- Month navigation -->
        <div class="drp-nav">
          <button class="drp-nav-btn" type="button" (click)="pickerPrevMonth()">
            <span class="material-icons">chevron_left</span>
          </button>
          <span class="drp-month-label">{{ pickerMonthLabel }}</span>
          <button class="drp-nav-btn" type="button" (click)="pickerNextMonth()">
            <span class="material-icons">chevron_right</span>
          </button>
        </div>

        <!-- Weekday headers + Calendar days -->
        <div class="drp-grid">
          <div class="drp-weekday" *ngFor="let wd of pickerWeekDays">
            {{ wd }}
          </div>
          <div
            *ngFor="let day of pickerCalendarDays"
            class="drp-day"
            [class.drp-empty]="!day"
            [class.drp-start]="pickerIsStart(day)"
            [class.drp-end]="pickerIsEnd(day)"
            [class.drp-in-range]="pickerIsInRange(day)"
            [class.drp-today]="pickerIsToday(day)"
            (click)="day && pickerSelectDay(day)"
            (mouseenter)="pickerHoverDate = day"
            (mouseleave)="pickerHoverDate = null"
          >
            {{ day ? day.getDate() : "" }}
          </div>
        </div>

        <!-- Footer -->
        <div class="drp-footer">
          <span class="drp-range-label">
            Select date range
            <strong *ngIf="pickerStartDate || pickerEndDate"
              >&nbsp;{{ pickerDisplayLabel }}</strong
            >
          </span>
          <div class="drp-actions">
            <button
              type="button"
              class="drp-clear-btn"
              (click)="clearDatePicker()"
            >
              Clear
            </button>
            <button
              type="button"
              class="drp-apply-btn"
              (click)="applyDatePicker()"
              [disabled]="!pickerStartDate"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- USERS TAB TABLE -->
  <div *ngIf="activeTab === 'users' && paginatedUsers.length > 0 && !isLoading">
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>USER</th>
              <th>REGISTERED</th>
              <th>PHONE NUMBER</th>
              <th>COLLEGE NAME</th>
              <th>CITY</th>
              <!--<th>PINCODE</th>-->
              <th class="text-center">JOBS APPLIED</th>
              <th class="text-center">PAYMENT</th>
              <th class="actions-col">ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let user of paginatedUsers; let i = index">
              <td class="user-cell">
                <div class="avatar">{{ user.initials }}</div>
                <div>
                  <strong>{{ user.name || "-" }}</strong>
                  <span>{{ user.email || "-" }}</span>
                </div>
              </td>

              <td>{{ user.registered | date: "MMM d, y" }}</td>
              <td>{{ user.phone_number || "-" }}</td>
              <td>{{ user.college_name || "-" }}</td>
              <td>{{ user.city || "-" }}</td>
              <!--<td>{{ user.pincode }}</td>-->

              <td class="text-center">
                {{ user.job_applied_count ?? user.jobs_applied_count ?? 0 }}
              </td>

              <td class="text-center">
                <span class="badge" [ngClass]="user.payment">
                  {{ user.payment | titlecase }}
                </span>
              </td>

              <td class="actions-col" (click)="$event.stopPropagation()">
                <button class="menu-btn" (click)="openUserDetails(user)">
                  <span class="material-icons">visibility</span>
                  View
                </button>
                <div class="dropdown" *ngIf="openMenuIndex === i">
                  <button>
                    <span class="material-icons">visibility</span>
                    View Profile
                  </button>
                  <button>
                    <span class="material-icons">mail</span>
                    Send Email
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINATION FOOTER -->
      <div class="pagination" *ngIf="totalUsers > 0">
        <p>
          Showing
          <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> –
          <strong>{{ getEndIndex() }}</strong>
          of <strong>{{ totalUsers }}</strong>
        </p>

        <div class="page-controls">
          <button
            (click)="changePage(currentPage - 1)"
            [disabled]="currentPage === 1"
          >
            ‹
          </button>

          <button *ngIf="currentPage > 2" (click)="changePage(1)">1</button>

          <span *ngIf="currentPage > 3" class="dots">…</span>

          <button *ngIf="currentPage > 1" (click)="changePage(currentPage - 1)">
            {{ currentPage - 1 }}
          </button>

          <button class="active">{{ currentPage }}</button>

          <button
            *ngIf="currentPage < totalPages"
            (click)="changePage(currentPage + 1)"
          >
            {{ currentPage + 1 }}
          </button>

          <span *ngIf="currentPage < totalPages - 2" class="dots">…</span>

          <button
            *ngIf="currentPage < totalPages - 1"
            (click)="changePage(totalPages)"
          >
            {{ totalPages }}
          </button>
          <button
            (click)="changePage(currentPage + 1)"
            [disabled]="currentPage === totalPages || totalPages === 0"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ENROLLMENTS TAB TABLE -->
  <div
    *ngIf="activeTab === 'enrollments' && enrollments.length > 0 && !isLoading"
  >
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>COURSE NAME</th>
              <th class="text-center">TOTAL ENROLLMENTS</th>
              <th class="actions-col">ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let course of enrollments">
              <td>
                <strong
                  class="truncate course-name"
                  matTooltip="{{ course.course_name }}"
                  matTooltipPosition="above"
                >
                  {{ course.course_name || "-" }}
                </strong>
              </td>
              <td class="text-center">
                <span class="badge paid">
                  {{ course.total_enrollments }} users
                </span>
              </td>

              <td class="actions-col">
                <button class="menu-btn" (click)="openCourseUsers(course)">
                  <span class="material-icons">visibility</span>
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINATION FOOTER -->
      <div class="pagination" *ngIf="totalEnrollments > 0">
        <p>
          Showing
          <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> –
          <strong>{{ getEndIndex() }}</strong>
          of <strong>{{ totalEnrollments }}</strong>
        </p>

        <div class="page-controls">
          <button
            (click)="changePage(currentPage - 1)"
            [disabled]="currentPage === 1"
          >
            ‹
          </button>

          <button *ngIf="currentPage > 2" (click)="changePage(1)">1</button>

          <span *ngIf="currentPage > 3" class="dots">…</span>

          <button *ngIf="currentPage > 1" (click)="changePage(currentPage - 1)">
            {{ currentPage - 1 }}
          </button>

          <button class="active">{{ currentPage }}</button>

          <button
            *ngIf="currentPage < totalPages"
            (click)="changePage(currentPage + 1)"
          >
            {{ currentPage + 1 }}
          </button>

          <span *ngIf="currentPage < totalPages - 2" class="dots">…</span>

          <button
            *ngIf="currentPage < totalPages - 1"
            (click)="changePage(totalPages)"
          >
            {{ totalPages }}
          </button>
          <button
            (click)="changePage(currentPage + 1)"
            [disabled]="currentPage === totalPages || totalPages === 0"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- QUIZZES TAB TABLE -->
  <div *ngIf="activeTab === 'quizzes' && quizzes.length > 0 && !isLoading">
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>QUIZ NAME</th>
              <th>COURSE</th>
              <th class="text-center">TOTAL ATTEMPTS</th>
              <th class="actions-col">ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let quiz of quizzes">
              <td>
                <strong
                  class="truncate quiz-name"
                  matTooltip="{{ quiz.quiz_name }}"
                  matTooltipPosition="above"
                >
                  {{ quiz.quiz_name || "-" }}
                </strong>
              </td>

              <td>
                <span
                  class="muted-text truncate course-name"
                  matTooltip="{{ quiz.course_name }}"
                  matTooltipPosition="above"
                >
                  {{ quiz.course_name || "-" }}
                </span>
              </td>

              <td class="text-center">
                <span class="badge pending">
                  {{ quiz.total_attempts }} attempts
                </span>
              </td>

              <td class="actions-col">
                <button class="menu-btn" (click)="openQuizAttempts(quiz)">
                  <span class="material-icons">visibility</span>
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINATION FOOTER -->
      <div class="pagination" *ngIf="totalQuizzes > 0">
        <p>
          Showing
          <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> –
          <strong>{{ getEndIndex() }}</strong>
          of <strong>{{ totalQuizzes }}</strong>
        </p>

        <div class="page-controls">
          <button
            (click)="changePage(currentPage - 1)"
            [disabled]="currentPage === 1"
          >
            ‹
          </button>

          <button *ngIf="currentPage > 2" (click)="changePage(1)">1</button>

          <span *ngIf="currentPage > 3" class="dots">…</span>

          <button *ngIf="currentPage > 1" (click)="changePage(currentPage - 1)">
            {{ currentPage - 1 }}
          </button>

          <button class="active">{{ currentPage }}</button>

          <button
            *ngIf="currentPage < totalPages"
            (click)="changePage(currentPage + 1)"
          >
            {{ currentPage + 1 }}
          </button>

          <span *ngIf="currentPage < totalPages - 2" class="dots">…</span>

          <button
            *ngIf="currentPage < totalPages - 1"
            (click)="changePage(totalPages)"
          >
            {{ totalPages }}
          </button>
          <button
            (click)="changePage(currentPage + 1)"
            [disabled]="currentPage === totalPages || totalPages === 0"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="no-data"
    *ngIf="activeTab === 'users' && !paginatedUsers.length && !isLoading"
  >
    <span class="material-icons">search_off</span>
    <h3>No users found</h3>
    <p>Try adjusting your search or filters</p>
  </div>

  <div
    class="no-data"
    *ngIf="activeTab === 'enrollments' && !enrollments.length && !isLoading"
  >
    <span class="material-icons">menu_book</span>
    <h3>No enrollments found</h3>
    <p>Try adjusting your search or filters</p>
  </div>

  <div
    class="no-data"
    *ngIf="activeTab === 'quizzes' && !quizzes.length && !isLoading"
  >
    <span class="material-icons">quiz</span>
    <h3>No quizzes found</h3>
    <p>Try adjusting your search or filters</p>
  </div>
</section>

<div class="skeleton-table" *ngIf="isLoading">
  <div class="skeleton-row" *ngFor="let _ of [1, 2, 3, 4, 5]">
    <div class="skeleton-user">
      <div class="skeleton-avatar"></div>
      <div class="skeleton-user-text">
        <div class="skeleton-line name"></div>
        <div class="skeleton-line email"></div>
      </div>
    </div>

    <div class="skeleton-line small"></div>
    <div class="skeleton-line tiny"></div>
    <div class="skeleton-line tiny"></div>
    <div class="skeleton-badge"></div>
    <div class="skeleton-action"></div>
  </div>
</div>

<app-dialog-enrollments
  *ngIf="showCourseDialog"
  [course]="selectedCourse"
  [loading]="isCourseLoading"
  [currentPage]="currentEnrollPage"
  [totalPages]="totalEnrollPages"
  (pageChange)="changeEnrollPage($event)"
  (close)="showCourseDialog = false"
>
</app-dialog-enrollments>

<app-dialog-quiz-attempts
  *ngIf="showQuizDialog && selectedQuiz"
  [data]="selectedQuiz"
  (close)="showQuizDialog = false"
>
</app-dialog-quiz-attempts>
